import { Pipe, PipeTransform } from '@angular/core';
import { exibirDataIgnorarTimeZoneLocal, timeToStringHHMM } from '../../../utils/date';

@Pipe({
  name: 'timeZone'
})
export class TimeZonePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value && (typeof value === 'string' || typeof value === 'number')) {
      
      const formattedDate = exibirDataIgnorarTimeZoneLocal(value);
    
      return formattedDate.split(' ')[1].substring(0, 5);
    }
    return "--:--:--";
  }

}
